import React from 'react'
import { Box, Typography, useMediaQuery } from '@mui/material';
import theme from './../../../theme';

const MapComponent = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: isMobile ? "10px" : "20px",
      }}
    >
      <Typography
        variant='p'
        sx={{
          fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
          fontWeight: 700,
          fontSize: isMobile ? "14px" : "18px", // Adjust font size for mobile
          textAlign: "center",
        }}
      >
        “Visit our Stores! We can’t wait to welcome you!”
      </Typography>

      <div style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: isMobile? "auto" : "400px",
        marginTop: "20px",
        borderRadius: "25px"
      }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1849.8788423843614!2d96.07937162963867!3d21.98226119445638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDU5JzA1LjAiTiA5NsKwMDQnNDEuNCJF!5e0!3m2!1sen!2smm!4v1769704405439!5m2!1sen!2smm"
          width="85%"
          height= {isMobile ? "300px" :"100%"}
          frameBorder="0"
          style={{
            border: 0,
            borderRadius: "15px", 
            overflow: "hidden", 
          }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
          title="Google Map"
        />

      </div>

    </Box>
  )
}

export default MapComponent
